import styled from 'styled-components';

const StyledPanelContainer = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	background-color: rgba(0, 0, 0, 0.9);
`;

export { StyledPanelContainer };
